<p>
  {{ 'scheduler.general.connection-error' | translate }}
</p>
<button (click)="retry()" [disabled]="loading"
        mat-flat-button>{{ (loading ? 'scheduler.general.connecting' : 'scheduler.general.retry') | translate }}
</button>
